import { useCallback, useState } from 'react';
import { Button, DatePicker, Form, Input } from 'antd';
import { FileExcelFilled } from '@ant-design/icons';
import xlsx from 'json-as-xlsx';
import FilteredList from '../filterList/FilteredList';
import { getMandateLinkDashboard, MandateLinkFilterPayload } from 'api/nach';
import moment from 'moment';

const dateFormat = 'DD/MM/YYYY';
type Props = {
  isLoading: boolean;
  onSubmit: (values: MandateLinkFilterPayload) => Promise<void>;
};
// const SourceApplicationName = sessionStorage.getItem('source')?.toString();

let filterPayload: MandateLinkFilterPayload = {};

function getFullDate(date: string) {
  if (date != null) {
    const dateMoment = moment(new Date(date)).format('DD/MM/YYYY HH:mm:ss');
    return dateMoment;
  }
}

const DashboardFilterForm = ({ onSubmit }: Props) => {
  // const { Option } = Select;

  const [form] = Form.useForm<MandateLinkFilterPayload>();
  const [filter, setFilter] = useState(filterPayload);
  const isAdmin = sessionStorage.getItem('isAdmin');
  const handleSubmit = useCallback(
    async (values: MandateLinkFilterPayload) => {
      let updatedValues = { ...values };
      updatedValues.Username = sessionStorage.getItem('user')?.toString();
      if (isAdmin != 'true') {
        updatedValues.SourceApplicationName = sessionStorage.getItem('source')?.toString();
      }

      setFilter(updatedValues);
    },
    [onSubmit, form]
  );

  function handleDownload(_e: any) {
    filter.isExtract = true;
    if (isAdmin != 'true') {
      filter.SourceApplicationName = sessionStorage.getItem('source')?.toString();
    }
    getMandateLinkDashboard(filter).then((_x) => {
      let settings = {
        fileName: 'MandateLinkDashboard -Report', // Name of the resulting spreadsheet
        extraLength: 3, // A bigger number means that columns will be wider
        writeMode: 'writeFile', // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
        writeOptions: {}, // Style options from https://github.com/SheetJS/sheetjs#writing-options
        RTL: false, // Display the columns from right-to-left (the default value is false)
      };

      const content = _x.data?.data || [];
      const updatedData = content.map((item: any, index) => ({
        ...item,
        EmailSentDate: getFullDate(item.EmailSentDate),
        SMSSentDate: getFullDate(item.SMSSentDate),
        CreatedOn: getFullDate(item.CreatedOn),
        ROWNUM: index + 1, // Add the row number (index + 1 to start from 1)
      }));
      let data = [
        {
          sheet: 'Sheet 1',
          columns: [
            { label: 'ROWNUM', value: 'ROWNUM' },
            { label: 'MandateRequestId', value: 'MandateId' },
            { label: 'LoanNumber', value: 'LANumber' },
            { label: 'MandateAmount', value: 'MandateAmount' },
            { label: 'LoanAmount', value: 'LoanAmount' },
            { label: 'ShortLink', value: 'ShortLink' },
            { label: 'EmailTo', value: 'SMSTo' },
            { label: 'EmailApplicantType', value: 'Email_ApplicantType' },
            { label: 'EmailID', value: 'EmailSendTo' },
            { label: 'EmailSentDate', value: 'EmailSentDate' },
            { label: 'EmailStatus', value: 'EmailStatus' },
            { label: 'SMSTo', value: 'SMSTo' },
            { label: 'SMSApplicantType', value: 'SMS_ApplicantType' },
            { label: 'ContactNo', value: 'ContactNo' },
            { label: 'SMSSentDate', value: 'SMSSentDate' },
            { label: 'SMSStatus', value: 'SMSStatus' },
            { label: 'CreatedBy', value: 'CreatedBy' },
            { label: 'Created Date', value: 'CreatedOn' },
          ],
          content: updatedData,
        },
      ];
      xlsx(data, settings);
    });
  }

  function handleReset(_e: any) {
    form.resetFields();
    let updatedFilter = { ...filter };
    updatedFilter = filterPayload;
    setFilter(updatedFilter);
  }

  return (
    <>
      <div className="submission-htmlForm">
        <Form<MandateLinkFilterPayload>
          form={form}
          onFinish={handleSubmit}
          layout="vertical"
          scrollToFirstError
          style={{ marginTop: '40px' }}
          className="standard-forms"
          initialValues={{
            ['Username']: sessionStorage.getItem('user')?.toString(),
            ['SourceApplicationName']: sessionStorage.getItem('source')?.toString(),
          }}
        >
          <div className="row">
            <div className="col-xs-12 col-sm-4 col-md-6">
              <div className="input-box">
                <Form.Item label={'LAN Number :'} name="LANumber" className="fieldTitle">
                  <Input placeholder={'Enter LAN Number'} />
                </Form.Item>
              </div>
            </div>
            <div className="col-xs-12 col-sm-4 col-md-6">
              <div className="input-box">
                <Form.Item label={'Mandate Request ID :'} name="MandateId" className="fieldTitle">
                  <Input placeholder={'Enter Mandate Request ID'} />
                </Form.Item>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12 col-sm-4 col-md-6">
              <div className="input-box">
                <Form.Item label={'From date:'} name="fromDate" className="fieldTitle">
                  <DatePicker format={dateFormat} />
                </Form.Item>
              </div>
            </div>
            <div className="col-xs-12 col-sm-4 col-md-6">
              <div className="input-box">
                <Form.Item
                  label={'To :'}
                  rules={[
                    {
                      validator(rule, value, callback) {
                        if (value < form.getFieldValue('fromDate')) {
                          rule.message = 'To Date should be greater than From Date';
                          callback('To Date should be greater than From Date');
                        } else {
                          callback();
                        }
                      },
                    },
                  ]}
                  name="toDate"
                  className="fieldTitle"
                >
                  <DatePicker format={dateFormat} />
                </Form.Item>
              </div>
            </div>
            <div style={{ float: 'right', marginBottom: '10px', marginTop: '30px' }}>
              <Button
                type="link"
                icon={<FileExcelFilled />}
                style={{ float: 'right', fontSize: '30px', color: 'green' }}
                onClick={handleDownload}
              ></Button>
              &nbsp; &nbsp;
              <Button
                type="primary"
                onClick={handleReset}
                style={{ float: 'right', marginRight: '5px' }}
              >
                {'CLEAR'}
              </Button>
              &nbsp; &nbsp;
              <Button
                type="primary"
                htmlType="submit"
                style={{ float: 'right', marginRight: '10px' }}
              >
                {'SEARCH'}
              </Button>
            </div>
          </div>
        </Form>
      </div>
      <FilteredList filter={{ ...filter }} />
    </>
  );
};

export default DashboardFilterForm;
